export default {"src":"/_next/static/media/shop-deco-1.c261cb81.svg","height":242,"width":252};